import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import Select from "react-select"
import {
  addInitialExamination,
  getInitialExaminationData,
} from "../../core/services/api/patientDiagnosisService"
import Button from "../Button"
import { MocUserRole } from "core/services/models/Enums"
import InputField from "../InputField"
export default function InitialExaminationView({
  setResInitialExaminationData,
  setIsInitialExaminationData,
  recordDetails,
  appointmentDetails,
  isReadOnly,
  scroll
}: any) {

  // add new Symptoms
  const symptom = { symptoms: "", direction: "", number: "", duration: "", remarks: "" }

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId

  const normalState = {
    pallor: "No",
    pallor2: "Absent",
    icterus: "Absent",
    icterus2: "",
    cynosis: "Absent",
    cynosis2: "",
    clubbing: "  0 (Absent)",
    clubbing2: "Absent",
    lymphNodes: "Non-palpable",
    lymphNodes2: "",
    oedema: "Absent",
    oedema2: "",
    jvp: "Normal",
    jvp2: "",
    nutritionalState: "Normal",
    nutritionalState2: "",
    gait: "Normal",
    gait2: "",
    heartSound: "",
    airEntry: "",
    abnormalSound: "",
    rsRemarks: "",
    glSound: "",
    ascites: "",
    lump: "",
    tenderness: "",
    paSize: "",
    lumpSite: "",
    nose: "",
    oralCavity: "",
    ear: "",
    mentalStatus: "",
    motorSystem: "",
    motorSystemSite: "",
    motorSystemPower: "",
    sensoryMotor: "",
    sensoryMotorSite: "",
    general: "",
    cheifComplaints: "",
  }
  const systematicNormalState = {
    cvs: "NAD",
    cvsOtherFinding: "",
    rs: "NAD",
    rsOtherFinding: "",
    rsRemarks: "",
    pa: "NAD",
    paOtherFinding: "",
    ent: "NAD",
    entOtherFinding: "",
    cns: "NAD",
    cnsotherFinding: "",
    pv: "NAD",
    pvOtherFinding: "",
    pr: "NAD",
    prOtherFinding: "",
  }
  const InitialExaminationOption = {
    ecog: [
      "0 - Fully active, able to carry on all pre-disease performance without restriction",
      "1 - Restricted in physically strenuous activity but ambulatory and able to carry out work of a light or sedentary nature, e.g., light house work, office work",
      "2 - Ambulatory and capable of all selfcare but unable to carry out any work activities; up and about more than 50% of waking hours",
      "3 - Capable of only limited selfcare; confined to bed or chair more than 50% of waking hours",
      "4 - Completely disabled; cannot carry on any selfcare; totally confined to bed or chair",
      "5 - Dead",
    ],
    kps: [
      "0 - Dead",
      "10 - Moribund, fatal processes progressing rapidly",
      "20 - Very sick; hospital admission necessary: active supportive treatment necessary",
      "30 - Severely disabled, hospital admission is indicated although death not imminent",
      "40 - Disabled; requires special care and assistance",
      "50 - Requires considerable assistance and frequent medical care",
      "60 - Requires occasional assistance, but is able to care for most of his personal needs",
      "70 - Cares for self; unable to carry on normal activity or to do active work",
      "80 - Normal activity with effort, some signs or symptoms of disease",
      "90 - Able to carry on normal activity; minor signs or symptoms of disease",
      "100 - Normal, no complaints, no evidence of disease"
    ],
    pallor: ["Yes", "No"],
    pallor2: ["Mild", "Moderate", "Severe"],
    icterus: ["Present", "Absent"],
    icterus2: [
      "Face & Neck, Bil < 5mgdl",
      "Chest & back, Bil 5-12 mg/dl",
      "Abdomen to knees, Bil 8-16 mg/dl",
      "Arms & legs below knees, Bil 10-18mg/dl",
      "Hands & feet, Bil >15mg/dl",
    ],
    cynosis: ["Absent", "Present"],
    cynosis2: ["Central", "Peripheral"],
    clubbing2: ["Absent", "Present"],
    clubbing: [
      "  0 (Absent)",
      "1 (Softening of nail bed)",
      "2 (Loss of hyponychial angle)",
      "3 (Convexity of nail)",
      "4 (Fingertips develop clubbed appearance, parrot beak)",
      "5 (Nail & skin develop glossy change with striation on nails, Osteoarthropathy)",
    ],
    lymphNodes: ["Non-palpable", "Palpable Unilateral", "Palpable Bilateral"],
    lymphNodes2: ["Cervical", "Supraclavicular", "Axillary", "Inguinal"],
    oedema: ["Absent", "Unilateral", "Bilateral"],
    oedema2: ["Pitting", "Non-pitting"],
    jvp: ["Normal", "High", "Low"],
    nutritionalState: ["Normal", "Average"],
    gait: ["Normal", "Abnormal"],
    cvs: ["NAD", "Significant"],
    heartSound: ["Normal", "Abnormal"],
    rs: ["NAD", "Significant"],
    airEntry: ["AEBE", "AE decreased"],
    abnormalSound: ["Rhonchi", "Crepitation’s", "Stridor", "Others"],
    pa: ["NAD", "Significant"],
    glSound: ["Yes", "No"],
    ascites: ["Yes", "No"],
    lump: ["Yes", "No"],
    tenderness: ["Yes", "No"],
    ent: ["NAD", "Significant"],
    nose: ["Normal", "Abnormal"],
    oralCavity: ["Normal", "Abnormal"],
    ear: ["Normal", "Abnormal"],
    cns: ["NAD", "Significant"],
    mentalStatus: ["Oriented", "Disoriented", "Unconscious"],
    motorSystem: ["Weakness Yes", "Weakness No"],
    sensoryMotor: ["Tingling & Numbness", "Pain"],
  }
  const directionValues = [
    "Nasal discharge",
    "Nasal polyp",
    "Epistaxis",
    "Ear discharge",
    "Deafness",
    "Tinnitus",
    "Swelling in neck",
    "Discharge from eyes",
    "Redness of eyes",
    "Swelling of eyes",
    "Itching in eyes",
    "Decreased vision",
    "Blindness",
    "Swelling in axilla",
    "Swelling in inguinal region",
    "Testicular swelling",
    "Breast lump",
    "Nipple discharge",
    "Breast Ulceration",
    "Breast fungating mass",
    "Breast swelling"
  ]
  const directionDropdown = ["Right", "Left"]
  const symptomsOption = [
    "Headache",
    "Vomiting",
    "Convulsion",
    "Vertigo",
    "Drowsiness",
    "Imbalance",
    "Visual disturbances",
    "Ulceration on tongue",
    "Swelling on tongue",
    "Ulceration in oral cavity",
    "Swelling in oral cavity",
    "Bleeding from oral cavity",
    "Ulceration on lips",
    "Swelling of lips",
    "Bleeding from lips",
    "Fever",
    "Night sweat",
    "Weight loss",
    "Significant weight loss",
    "Fatigue",
    "Diarrhoea",
    "Abdominal pain",
    "Breathlessness at rest",
    "Breathlessness on exertion",
    "Chest pain",
    "Haemoptysis",
    "Hematemesis",
    "PR Bleeding",
    "Blackening of stools",
    "Distension of abdomen",
    "Bloating",
    "Nausea",
    "Perianal itching",
    "Perianal mass",
    "Perianal ulceration",
    "PV bleeding",
    "PV white",
    "Discharge",
    "PV red discharge",
    "PV ulceration",
    "Urinary increased frequency of urination",
    "Difficulty in urination",
    "Haematuria",
    "Penile swelling",
    "Penile ulceration",
    "Abdominal lump",
    "Pedal oedema",
    "Bone pain",
    "Backache",
    "Anemia",
    "Leucocytosis",
    "Leucopenia",
    "Thrombocytopenia",
    "Thrombocytosis",
    "Jaundice",
    "Nasal discharge",
    "Epistaxis",
    "Nasal polyp",
    "Ear discharge",
    "Deafness",
    "Tinnitus",
    "Swelling in neck",
    "Discharge from eyes",
    "Redness of eyes",
    "Swelling of eyes",
    "Itching in eyes",
    "Decreased vision",
    "Blindness",
    "Swelling in axilla",
    "Swelling in inguinal region",
    "Testicular swelling",
    "Breast lump",
    "Nipple discharge",
    "Breast Ulceration",
    "Breast fungating mass",
    "Breast swelling",
    "Others"
  ]
  const daysofYear = {
    daysofweek: ["Day/Days", "Month/Months", "Year/Years", "Week/Weeks"],
  }

  const [symptoms, setSymptoms] = useState([symptom])
  const [formInitialExaminationErrors, setFormInitialExaminationErrors] =
    useState({})
  const [isInitialExaminationSubmit, setIsInitialExaminationSubmit] =
    useState(false)
  const initialState = {
    pallor: "",
    pallor2: "",
    icterus: "",
    icterus2: "",
    cynosis: "",
    cynosis2: "",
    clubbing: "",
    clubbing2: "",
    lymphNodes: "",
    lymphNodes2: "",
    oedema: "",
    oedema2: "",
    jvp: "",
    jvp2: "",
    nutritionalState: "",
    nutritionalState2: "",
    gait: "",
    gait2: "",
    remarks: "",
    cvs: "",
    heartSound: "",
    cvsOtherFinding: "",
    rs: "",
    rsOtherFinding: "",
    rsRemarks: "",
    airEntry: "",
    abnormalSound: "",
    pa: "",
    paOtherFinding: "",
    glSound: "",
    ascites: "",
    lump: "",
    lumpSite: "",
    tenderness: "",
    paSize: "",
    ent: "",
    entOtherFinding: "",
    nose: "",
    oralCavity: "",
    ear: "",
    mentalStatus: "",
    motorSystem: "",
    motorSystemSite: "",
    motorSystemPower: "",
    sensoryMotor: "",
    sensoryMotorSite: "",
    cns: "",
    cnsotherFinding: "",
    general: "",
    pv: "",
    pvOtherFinding: "",
    pr: "",
    prOtherFinding: "",
    cheifComplaints: "",
    provisionalDiagnosis: "",
    ecogStatus: "",
    kps: "",
  }
  const [intialExaminationData, setIntialExaminationData] =
    useState(initialState)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [ecogValue, setecogValue] = useState("")
  const [kpsValue, setkpsValue] = useState("")
  const [symptomValue, setsymptomValue] = useState("")

  const userRole = useSelector((state: any) => state?.user?.role)

  const validateInitialExamination = (values: any) => {
    const errors: any = {}
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

    // drpodown validation
    return errors
  }
  const monthView: any = daysofYear?.daysofweek.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const direc: any = directionDropdown.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const symptomsOptions = symptomsOption.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const InitialExaminationOptionOptions = InitialExaminationOption.ecog.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const InitialExaminationOptionkpsOptions = InitialExaminationOption.kps.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const pallor = InitialExaminationOption.pallor.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const pallor_2 = InitialExaminationOption.pallor2.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Icterus = InitialExaminationOption.icterus.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Cynosis = InitialExaminationOption.cynosis.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Cynosis_2 = InitialExaminationOption.cynosis2.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Clubbing = InitialExaminationOption.clubbing.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const LymphNode = InitialExaminationOption.lymphNodes.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const LymphNode_2 = InitialExaminationOption.lymphNodes2.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const JVP = InitialExaminationOption.jvp.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Oedemas = InitialExaminationOption.oedema.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Oedemas_2 = InitialExaminationOption.oedema2.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const NutritionalState = InitialExaminationOption.nutritionalState.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Gait = InitialExaminationOption.gait.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const CNS = InitialExaminationOption.cns.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const CVS = InitialExaminationOption.cvs.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const ENTs = InitialExaminationOption.ent.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const RS = InitialExaminationOption.rs.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const PA = InitialExaminationOption.pa.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const PV = InitialExaminationOption.rs.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const PR = InitialExaminationOption.rs.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const handleInitialExaminationSubmit = (e: any) => {
    e.preventDefault()
    if (scroll) {
      scroll()
    }
    setFormInitialExaminationErrors(
      validateInitialExamination(intialExaminationData)
    )
    setIsInitialExaminationSubmit(true)
  }

  function onValueChange(source: any, value: any) {
    const values: any = { ...intialExaminationData }
    setIntialExaminationData({ ...values, ...{ ecogStatus: value } })
  }

  function onValueChanges(source: any, value: any) {
    const values: any = { ...intialExaminationData }
    setIntialExaminationData({ ...values, ...{ kps: value } })
  }

  function onValueChanged(source: any, value: any, index: any) {
    const values: any = [...symptoms]
    if (value === "Others") {
      values[index][source] = value
      values[index]["symotomsOthers"] = ""
      setSymptoms([...values])
    } else {
      values[index][source] = value
      delete values[index]["symotomsOthers"]
      setSymptoms([...values])
    }
  }

  useEffect(() => {
    if (scroll) {
      scroll()
    }
  }, [])

  useEffect(() => {
    // setIsLoading(true)
    getInitialExaminationData(recordId)
      .then((data: any) => {
        const res = data.data
        setIntialExaminationData({
          pallor: res?.generalExamination?.pallor,
          pallor2: res?.generalExamination?.PallorOption,
          icterus: res?.generalExamination?.icterus,
          icterus2: "",
          cynosis: res?.generalExamination?.cynosis,
          cynosis2: res?.generalExamination?.cynosisOption,
          clubbing: res?.generalExamination?.clubbing,
          clubbing2: "",
          lymphNodes: res?.generalExamination?.LymphNodes,
          lymphNodes2: res?.generalExamination?.LymphNodesOption,
          oedema: res?.generalExamination?.edema,
          oedema2: res?.generalExamination?.edemaOption,
          jvp: res?.generalExamination?.jvp,
          jvp2: "",
          nutritionalState: res?.generalExamination?.nutritionalState,
          nutritionalState2: "",
          gait: res?.generalExamination?.gait,
          gait2: "",
          remarks: res?.generalExamination?.remarks,
          cvs: res?.systemicExamination?.CVS,
          heartSound: "",
          cvsOtherFinding: res?.systemicExamination?.cvsOtherFinding,
          rs: res?.systemicExamination?.RS,
          rsOtherFinding: res?.systemicExamination?.rsOtherFinding,
          rsRemarks: "",
          airEntry: "",
          abnormalSound: "",
          pa: res?.systemicExamination?.PA,
          paOtherFinding: res?.systemicExamination?.paOtherFinding,
          glSound: "",
          ascites: "",
          lump: "",
          lumpSite: "",
          tenderness: "",
          paSize: "",
          ent: res?.systemicExamination?.ENT,
          entOtherFinding: res?.systemicExamination?.entOtherFinding,
          nose: "",
          oralCavity: "",
          ear: "",
          mentalStatus: "",
          motorSystem: "",
          motorSystemSite: "",
          motorSystemPower: "",
          sensoryMotor: "",
          sensoryMotorSite: "",
          cns: res?.systemicExamination?.CNS,
          cnsotherFinding: res?.systemicExamination?.cnsOtherFinding,
          general: "",
          pv: res?.systemicExamination?.pv,
          pvOtherFinding: res?.systemicExamination?.pvOtherFinding,
          pr: res?.systemicExamination?.pr,
          prOtherFinding: res?.systemicExamination?.prOtherFinding,
          cheifComplaints: "",
          provisionalDiagnosis:
            res?.systemicExamination?.systematicOtherFinding,
          ecogStatus: res?.ecogStatus,
          kps: res?.kps,
        })
        const temp = res?.chiefComplaints.map((e: any) => {
          if (!symptomsOption.includes(e?.symptoms)) {
            let t = { ...e }
            t["symotomsOthers"] = t["symptoms"]
            t["symptoms"] = "Others"
            return { ...t }
          } else {
            return { ...e }
          }
        })
        setSymptoms(temp)
        setIsLoading(false)
      })
      .catch((err: any) => {
        console.error(err)
        setIsLoading(false)
      })
  }, [appointmentId, recordId])

  useEffect(() => {
    if (
      Object.keys(formInitialExaminationErrors).length === 0 &&
      isInitialExaminationSubmit
    ) {
      // setIsLoading(true)
      addInitialExamination(
        { ...intialExaminationData, symptoms },
        {
          centerId,
          consultantId,
          patientId,
          appointmentId,
          recordId,
        }
      )
        .then((data) => {
          setIsLoading(false)
          setResInitialExaminationData(data)
          setIsInitialExaminationData(true)
        })
        .catch((err) => {
          setIsLoading(false)
          console.error(err)
        })
    }
  }, [formInitialExaminationErrors])

  return (
    <>
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <form onSubmit={handleInitialExaminationSubmit}>
        <div className="initial-examination-container">
          <div className="heading">Initial Examination</div>
          <div className="com">
            <label htmlFor="">Chief Complaints</label>
          </div>
          {symptoms.map((e: any, index) => {
            return (
              <div className="comorbidities">
                <div className="col-md-2 col-lg-3">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    onChange={(option: any) => {
                      const value: any = symptomsOptions?.find(
                        (each: any) => each?.label == option?.value
                      )
                      if (!directionValues?.includes(value?.label)) {
                        const tem = [...symptoms]
                        tem[index].direction = ""
                        setSymptoms(tem)
                      }
                      onValueChanged("symptoms", value?.label, index)
                    }}
                    defaultInputValue={symptomValue}
                    value={symptomsOptions.filter(({ value }) => value === e?.symptoms)}
                    isSearchable={true}
                    onInputChange={(e: any) => {
                      setsymptomValue(e)
                    }}
                    options={symptomsOptions}
                    isDisabled={isReadOnly} />
                  {
                    Object.keys(e).includes("symotomsOthers") && (
                      <div className="mt-3">
                        <textarea
                          onChange={(e: any) => {
                            const values: any = [...symptoms]
                            values[index]["symotomsOthers"] = e?.target.value
                            setSymptoms(values)
                          }}
                          value={e?.symotomsOthers}
                          placeholder="Others"
                          readOnly={isReadOnly}
                          rows={5}
                          cols={50}
                        />
                      </div>
                    )
                  }
                </div>
                <div className="col-md-1.5 col-lg-1.5">
                  {
                    directionValues?.includes(e?.symptoms) && (

                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "1px solid #ccd0e7",
                            borderRadius: "10px"
                          })
                        }}
                        isDisabled={isReadOnly}
                        onChange={(option: any) => {
                          const values = [...symptoms]
                          values[index].direction = option?.value
                          setSymptoms([...values])
                        }}
                        options={direc}
                        value={direc?.filter(
                          ({ label }: any) =>
                            label === e.direction
                        )}
                        placeholder="Select.."
                      />
                    )

                  }
                </div>
                < div className="col-md-2 col-lg-2" >
                  <InputField
                    handleChange={(e) => {
                      const value = e.target.value
                      let res = ""
                      value.split("").forEach((ele) => {
                        let k = ele.charCodeAt(0)
                        if (k >= 48 && k <= 57) {
                          res += ele
                        }
                      })
                      const values = [...symptoms]
                      values[index].number = res
                      setSymptoms([...values])
                    }}
                    placeholder={"Number"}
                    value={symptoms[index].number}
                    readOnly={
                      symptoms[index].symptoms === "" ? true : false || isReadOnly
                    }></InputField>
                </div>
                <div className="col-md-2 col-lg-2">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={
                      symptoms[index].symptoms === "" ? true : false || isReadOnly
                    }
                    options={monthView}
                    onChange={(option: any) => {
                      const values = [...symptoms]
                      values[index].duration = option?.value
                      setSymptoms([...values])
                    }}
                    value={monthView.filter(
                      ({ label }: any) =>
                        label === e.duration
                    )}
                    defaultValue={monthView}
                  />
                </div>
                <div className="col-md-2 col-lg-3">
                  <div className="d-flex align-items-center">
                    <div>
                      {(symptoms[index].symptoms === "" || isReadOnly) ? <textarea
                        name=""
                        id="Remarks"
                        className={`disabled`}
                        onChange={(e) => {
                          const values = [...symptoms]
                          values[index].remarks = e.target.value
                          setSymptoms([...values])
                        }}
                        value={symptoms[index].remarks}
                        placeholder="Remarks"
                        readOnly={
                          symptoms[index].symptoms === "" ? true : false || isReadOnly
                        }
                      /> : <textarea
                        name=""
                        id="Remarks"
                        onChange={(e) => {
                          const values = [...symptoms]
                          values[index].remarks = e.target.value
                          setSymptoms([...values])
                        }}
                        value={symptoms[index].remarks}
                        placeholder="Remarks"
                        readOnly={
                          symptoms[index].symptoms === "" ? true : false || isReadOnly
                        }
                      />}

                    </div>
                    {
                      !isReadOnly ?
                        <div
                          className="delete-icon"
                          onClick={() => {
                            if (symptoms.length > 1) {
                              const values = [...symptoms]
                              values.splice(index, 1)
                              setSymptoms(values)
                            }
                          }}>
                          <img src="../../assets/images/delete-icon.svg" alt="" />
                        </div>
                        : ""
                    }
                  </div>
                </div>
              </div>
            )
          })}

          {
            !isReadOnly ?
              <div className="comorbidities add-new">
                <div
                  className="add-new-button"
                  onClick={() => setSymptoms([...symptoms, symptom])}>
                  Add New
                </div>
              </div> : ""
          }
          <div className="kps-ecog">
            <div className="ecog col-md-6">
              <label htmlFor="" className="sub-heading">
                ECOG Status:
              </label>

              <Select
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    border: "1px solid #ccd0e7",
                    borderRadius: "10px"
                  })
                }}
                onChange={(option: any) => {
                  const value: any = InitialExaminationOptionOptions?.find(
                    (each: any) => each?.label === option?.value
                  )
                  onValueChange("ecogStatus", value?.label)
                }}
                defaultInputValue={ecogValue}
                value={InitialExaminationOptionOptions.filter(({ value }) => value === intialExaminationData.ecogStatus)}
                isSearchable={true}
                onInputChange={(e: any) => {
                  setecogValue(e)
                }}
                options={InitialExaminationOptionOptions}
                isDisabled={isReadOnly} />
            </div>
            <div className="ecog col-md-5">
              <label htmlFor="" className="sub-heading">
                KPS:
              </label>
              <div>
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  onChange={(option: any) => {
                    const value: any = InitialExaminationOptionkpsOptions?.find(
                      (each: any) => each?.label === option?.value
                    )
                    onValueChanges("kps", value?.label)
                  }}
                  defaultInputValue={kpsValue}
                  value={InitialExaminationOptionkpsOptions.filter(({ value }) => value === intialExaminationData.kps)}
                  isSearchable={true}
                  onInputChange={(e: any) => {
                    setkpsValue(e)
                  }}
                  options={InitialExaminationOptionkpsOptions}
                  isDisabled={isReadOnly} />
              </div>
            </div>
          </div>
          <div className="sub-heading mt-5">General Examination</div>
          {
            userRole !== MocUserRole.FRONT_DESK ?
              <Button
                type="button"
                text="Mark all Normal"
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIntialExaminationData({
                    ...intialExaminationData,
                    ...normalState
                  })
                }}
                disabled={isReadOnly}
              />
              :
              <Button
                type="button"
                text="Mark all Normal"
                // className="mark-all-normal mt-2"
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIntialExaminationData({
                    ...intialExaminationData,
                    ...normalState
                  })
                }}
                disabled={isReadOnly}
              />
          }

          <div className="row my-5">
            <div className="col-md-6 row input-row">
              <div className="col-md-3 detail-key align-item-center">Pallor:</div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={pallor}
                  defaultValue={pallor}
                  isDisabled={isReadOnly}
                  onChange={(option: any) => {

                    if (option?.value === "" ||
                      option?.value === "No") {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        pallor: option?.value,
                        pallor2: ""
                      })
                    } else {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        pallor: option?.value,
                      })
                    }
                  }}
                  placeholder="Pallor"
                  value={pallor.filter(({ label }: any) => label === intialExaminationData.pallor)
                  }
                />
              </div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={pallor_2}
                  defaultValue={pallor_2}
                  onChange={(option: any) => {
                    if (intialExaminationData.pallor === "" ||
                      intialExaminationData.pallor === "No")
                      setIntialExaminationData({
                        ...intialExaminationData,
                        pallor2: "",
                      })

                    else
                      setIntialExaminationData({
                        ...intialExaminationData,
                        pallor2: option?.value,
                      })
                  }}
                  isDisabled={intialExaminationData.pallor === "" || intialExaminationData.pallor === "No" || isReadOnly}
                  value={pallor_2.filter(({ label }: any) => label === intialExaminationData.pallor2)
                  }
                />
              </div>
            </div>
            <div className="col-md-6 row input-row">
              <div className="col-md-4 col-lg-4  detail-key align-item-center">Icterus:</div>
              <div className="col-md-4  col-lg-6 icterus">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}

                  options={Icterus}
                  defaultValue={Icterus}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      icterus: option?.value,
                    })
                  }}
                  placeholder="Select"
                  value={Icterus.filter(({ label }: any) => label === intialExaminationData.icterus)
                  }
                />
              </div>
            </div>
          </div><div className="row my-5">
            <div className="col-md-6 row input-row">
              <div className="col-md-3 detail-key align-item-center">Cyanosis:</div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}

                  options={Cynosis}
                  defaultValue={Cynosis}
                  onChange={(option: any) => {
                    if (option?.value === "" ||
                      option?.value === "Absent") {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        cynosis: option?.value,
                        cynosis2: ""
                      })
                    } else {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        cynosis: option?.value,
                      })
                    }
                  }}
                  placeholder="Select"
                  value={Cynosis.filter(({ label }: any) => label === intialExaminationData.cynosis)
                  }
                />
              </div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={Cynosis_2}
                  defaultValue={Cynosis_2}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      cynosis2: option?.value,
                    })
                  }}
                  isDisabled={intialExaminationData.cynosis === "" ||
                    intialExaminationData.cynosis === "Absent" || isReadOnly}
                  placeholder="Select"
                  value={Cynosis_2.filter(({ label }: any) => label === intialExaminationData.cynosis2)
                  }
                />
              </div>
            </div>
            <div className="col-md-6 row input-row">
              <div className="col-md-4 col-lg-4 detail-key align-item-center">Clubbing:</div>
              <div className="col-md-4 col-lg-6 clubbing">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={Clubbing}
                  defaultValue={Clubbing}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      clubbing: option?.value,
                    })
                  }}
                  placeholder="Select"
                  value={Clubbing.filter(({ label }: any) => label === intialExaminationData.clubbing)
                  }
                />
              </div>
            </div>
          </div><div className="row my-5">
            <div className="col-md-6 row input-row">
              <div className="col-md-3 detail-key align-item-center">
                Lymph Nodes:
              </div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={LymphNode}
                  defaultValue={LymphNode}
                  onChange={(option: any) => {
                    if (option?.value === "" ||
                      option?.value === "Non-palpable") {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        lymphNodes: option?.value,
                        lymphNodes2: ""
                      })
                    } else {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        lymphNodes: option?.value,
                      })
                    }
                  }}
                  placeholder="Select"
                  value={LymphNode.filter(({ label }: any) => label === intialExaminationData.lymphNodes)
                  }
                />
              </div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={LymphNode_2}
                  defaultValue={LymphNode_2}
                  onChange={(option: any) => {
                    if (intialExaminationData.lymphNodes === "" ||
                      intialExaminationData.lymphNodes === "Non-palpable")
                      setIntialExaminationData({
                        ...intialExaminationData,
                        lymphNodes2: "",
                      })

                    else
                      setIntialExaminationData({
                        ...intialExaminationData,
                        lymphNodes2: option?.value,
                      })
                  }}
                  isDisabled={intialExaminationData.lymphNodes === "" ||
                    intialExaminationData.lymphNodes === "Non-palpable" || isReadOnly}
                  placeholder="Select"
                  value={LymphNode_2.filter(({ label }: any) => label === intialExaminationData.lymphNodes2)
                  }
                />
              </div>
            </div>

            {/**/}

            <div className="col-md-6 row input-row">
              <div className="col-md-4 col-lg-4 detail-key align-item-center">JVP:</div>
              <div className="col-md-4 col-lg-6 clubbing">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={JVP}
                  defaultValue={JVP}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      jvp: option?.value,
                    })
                  }}
                  placeholder="Select"
                  value={JVP.filter(({ label }: any) => label === intialExaminationData.jvp)
                  }
                />
              </div>
            </div>
          </div><div className="row my-5">
            <div className="col-md-6 row input-row">
              <div className="col-md-3 detail-key align-item-center">Oedema:</div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={Oedemas}
                  defaultValue={Oedemas}
                  onChange={(option: any) => {
                    if (option?.value === "" ||
                      option?.value === "Absent") {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        oedema: option?.value,
                        oedema2: ""
                      })
                    } else {
                      setIntialExaminationData({
                        ...intialExaminationData,
                        oedema: option?.value,
                      })
                    }
                  }}
                  placeholder="Select"
                  value={Oedemas.filter(({ label }: any) => label === intialExaminationData.oedema)
                  }
                />
              </div>
              <div className="col-md-4">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={Oedemas_2}
                  defaultValue={Oedemas_2}
                  isDisabled={intialExaminationData.oedema === "" ||
                    intialExaminationData.oedema === "Absent" || isReadOnly}
                  onChange={(option: any) => {
                    if (intialExaminationData.oedema === "" ||
                      intialExaminationData.oedema === "No")
                      setIntialExaminationData({
                        ...intialExaminationData,
                        oedema2: "",
                      })

                    else
                      setIntialExaminationData({
                        ...intialExaminationData,
                        oedema2: option?.value,
                      })
                  }}
                  placeholder="Select"
                  value={Oedemas_2.filter(({ label }: any) => label === intialExaminationData.oedema2)
                  }
                />
              </div>
            </div>
            <div className="col-md-6 row input-row">
              <div className="col-md-4 col-lg-4 detail-key align-item-center">Nutritional State:</div>
              <div className="col-md-4 col-lg-6 clubbing">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={NutritionalState}
                  defaultValue={NutritionalState}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      nutritionalState: option?.value,
                    })
                  }}
                  placeholder="Select"
                  value={NutritionalState.filter(({ label }: any) => label === intialExaminationData.nutritionalState)
                  }
                />
              </div>
            </div>
          </div><div className="row my-5">
            <div className="col-md-6 row input-row jvp">
              <div className="col-md-3 detail-key align-item-center">Gait:</div>
              <div className="col-md-8">
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  isDisabled={isReadOnly}
                  options={Gait}
                  defaultValue={Gait}
                  onChange={(option: any) => {
                    setIntialExaminationData({
                      ...intialExaminationData,
                      gait: option?.value,
                    })
                  }}
                  placeholder="Select"
                  value={Gait.filter(({ label }: any) => label === intialExaminationData.gait)
                  }
                />
              </div>
            </div>
            <div className="col-md-6 row input-row">
              <div className="col-md-4 col-lg-4 detail-key align-item-center">Remarks:</div>
              <div className="col-md-5 col-lg-6">
                <InputField
                  handleChange={(e) => setIntialExaminationData({
                    ...intialExaminationData,
                    remarks: e.target.value,
                  })}
                  value={intialExaminationData.remarks}
                  readOnly={intialExaminationData.gait === "" || intialExaminationData.gait === "Normal" || isReadOnly}
                />
              </div>
            </div>
          </div>
          <div className="heading">Systemic Examination:</div>
          {
            userRole !== MocUserRole.FRONT_DESK ?
              <Button
                type="button"
                text="Mark all Normal"
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIntialExaminationData({
                    ...intialExaminationData,
                    ...systematicNormalState
                  })
                }}
                disabled={isReadOnly}
              />
              :
              <Button
                type="button"
                text="Mark all Normal"
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIntialExaminationData({
                    ...intialExaminationData,
                    ...systematicNormalState
                  })
                }}
                disabled={isReadOnly}
              />
          }

          <div className="systematic">
            <div className="cns my-2 mb-4">
              <div className="row my-2">
                <div className="col-md-6 row">
                  <div className="col-md-2 col-lg-2 detail-key pt-3">CNS:</div>
                  <div className="col-md-5 col-lg-8">
                    <Select
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #ccd0e7",
                          borderRadius: "10px"
                        })
                      }}
                      options={CNS}
                      isDisabled={isReadOnly}
                      defaultValue={CNS}
                      onChange={(option: any) => {
                        if (option === "NAD") {
                          setIntialExaminationData({
                            ...intialExaminationData,
                            cns: option?.value,
                            cnsotherFinding: ""
                          })
                        } else {
                          setIntialExaminationData({
                            ...intialExaminationData,
                            cns: option?.value,
                          })
                        }
                      }}
                      placeholder="Select"
                      value={CNS.filter(({ label }: any) => label === intialExaminationData.cns)
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 row">
                  <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                  <div className="col-md-6 col-lg-6">
                    <InputField
                      handleChange={(e) => setIntialExaminationData({
                        ...intialExaminationData,
                        cnsotherFinding: e.target.value,
                      })}
                      value={intialExaminationData.cnsotherFinding}
                      readOnly={(intialExaminationData.cns === "" ||
                        (intialExaminationData.cns === "NAD"
                          ? true
                          : false) ||
                        isReadOnly)} />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2 mb-4">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3">CVS:</div>
                <div className="col-md-5 col-lg-8 cvs">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={CVS}
                    defaultValue={CVS}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          cvs: option?.value,
                          cvsOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          cvs: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={CVS.filter(({ label }: any) => label === intialExaminationData.cvs)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      cvsOtherFinding: e.target.value,
                    })}
                    value={intialExaminationData.cvsOtherFinding}
                    readOnly={(intialExaminationData.cvs === "" ||
                      intialExaminationData.cvs === "NAD"
                      ? true
                      : false) || isReadOnly} />
                </div>
              </div>
            </div>
            <div className="row my-2 ent mb-4">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3">ENT:</div>
                <div className="col-md-5 col-lg-8">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={ENTs}
                    defaultValue={ENTs}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          ent: option?.value,
                          entOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          ent: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={ENTs.filter(({ label }: any) => label === intialExaminationData.ent)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    placeholder=""
                    value={intialExaminationData.entOtherFinding}
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      entOtherFinding: e.target.value,
                    })}
                    readOnly={(intialExaminationData.ent === "" ||
                      intialExaminationData.ent === "NAD"
                      ? true
                      : false)
                      || isReadOnly}
                  />
                </div>
              </div>
            </div>

            <div className="row my-2 mb-4 rs">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3 ">RS:</div>
                <div className="col-md-5 col-lg-8 rs">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={RS}
                    defaultValue={RS}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          rs: option?.value,
                          rsOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          rs: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={RS.filter(({ label }: any) => label === intialExaminationData.rs)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      rsOtherFinding: e.target.value,
                    })}
                    value={intialExaminationData.rsOtherFinding}
                    readOnly={(intialExaminationData.rs === "" ||
                      intialExaminationData.rs === "NAD"
                      ? true
                      : false) || isReadOnly} />
                </div>
              </div>
            </div>
            <div className="row my-2 mb-4 rs">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3 ">PA:</div>
                <div className="col-md-5 col-lg-8 rs">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={PA}
                    defaultValue={PA}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pa: option?.value,
                          paOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pa: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={PA.filter(({ label }: any) => label === intialExaminationData.pa)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      paOtherFinding: e.target.value,
                    })}
                    value={intialExaminationData.paOtherFinding}
                    readOnly={(intialExaminationData.pa === "" ||
                      intialExaminationData.pa === "NAD"
                      ? true
                      : false) || isReadOnly} />
                </div>
              </div>
            </div>
            <div className="row my-2 mb-4 rs">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3 ">PV:</div>
                <div className="col-md-5 col-lg-8 rs">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={PV}
                    defaultValue={PV}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pv: option?.value,
                          pvOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pv: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={PV.filter(({ label }: any) => label === intialExaminationData.pv)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      pvOtherFinding: e.target.value,
                    })}
                    value={intialExaminationData.pvOtherFinding}
                    readOnly={(intialExaminationData.pv === "" ||
                      intialExaminationData.pv === "NAD"
                      ? true
                      : false) || isReadOnly} />
                </div>
              </div>
            </div>
            <div className="row my-2 mb-4 rs">
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-2 detail-key pt-3 ">PR:</div>
                <div className="col-md-5 col-lg-8 rs">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    isDisabled={isReadOnly}
                    options={PR}
                    defaultValue={PR}
                    onChange={(option: any) => {
                      if (option === "NAD") {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pr: option?.value,
                          prOtherFinding: ""
                        })
                      } else {
                        setIntialExaminationData({
                          ...intialExaminationData,
                          pr: option?.value,
                        })
                      }
                    }}
                    placeholder="Select"
                    value={PR.filter(({ label }: any) => label === intialExaminationData.pr)
                    }
                  />
                </div>
              </div>
              <div className="col-md-6 row">
                <div className="col-md-2 col-lg-4 detail-key pt-3">Details:</div>
                <div className="col-md-5 col-lg-6">
                  <InputField
                    handleChange={(e) => setIntialExaminationData({
                      ...intialExaminationData,
                      prOtherFinding: e.target.value,
                    })}
                    value={intialExaminationData.prOtherFinding}
                    readOnly={(intialExaminationData.pr === "" ||
                      intialExaminationData.pr === "NAD"
                      ? true
                      : false) || isReadOnly} />
                </div>
              </div>
            </div>
            <div className="provisonal-d row">
              <div className="col-md-1 col-lg-1 detail-key">Other Findings:</div>
              <div className="col-md-9 col-lg-10">
                <InputField
                  handleChange={(e) => setIntialExaminationData({
                    ...intialExaminationData,
                    provisionalDiagnosis: e.target.value,
                  })}
                  value={intialExaminationData.provisionalDiagnosis}
                  readOnly={isReadOnly}
                />
              </div>
            </div>
            <div>
            </div>
            <div className="vital-submit">
              {isReadOnly ? "" : <Button text="Save" id="save" type="submit"></Button>}
            </div>
          </div>
        </div >
      </form >
    </>
  )
}
